import { render, staticRenderFns } from "./AdminScreen.vue?vue&type=template&id=015432ad&scoped=true&"
import script from "./AdminScreen.vue?vue&type=script&lang=ts&"
export * from "./AdminScreen.vue?vue&type=script&lang=ts&"
import style0 from "./AdminScreen.vue?vue&type=style&index=0&id=015432ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015432ad",
  null
  
)

export default component.exports